export const LEAP_CARD_PATTERN = /^302\d \d{4} \d{4} \d{4}$/
export const LEAP_CARD_REQUIRED_MESSAGE =
  'Please enter the YA / Student Leap Card number.'
export const LEAP_CARD_INVALID_MESSAGE =
  'YA / Student Leap Card Number not valid.'

// Matches fare keys ('student'), passenger type ids
// ('BONUS_SCHEME_GROUP.THE_YOUNG') and display names ('Young Adult / Student')
export const isYoungAdultPassengerType = (passengerType: string): boolean => {
  const value = passengerType.toLowerCase()

  return value.includes('student') || value.includes('young')
}

// Auto-format as the user types: keep only digits (max 16) and group in fours
export const formatLeapCardNumber = (value: string): string => value
  .replace(/\D/g, '')
  .slice(0, 16)
  .replace(/(.{4})/g, '$1 ')
  .trim()

// Index in a formatted number that sits just after its nth digit
const positionAfterDigit = (value: string, digitCount: number): number => {
  if (digitCount <= 0) return 0

  let digitsSeen = 0

  for (let i = 0; i < value.length; i++) {
    if (/\d/.test(value[i])) digitsSeen++
    if (digitsSeen === digitCount) return i + 1
  }

  return value.length
}

// Reformats what the user typed while keeping the caret on the same digit,
// so editing the middle of the number doesn't jump to the end. Backspace or
// delete over one of the grouping spaces removes the adjacent digit instead.
export const formatLeapCardInput = (
  rawValue: string,
  caret: number,
  previousValue: string,
  inputType?: string
): { value: string; caret: number } => {
  let digits = rawValue.replace(/\D/g, '').slice(0, 16)
  let digitsBeforeCaret = rawValue.slice(0, caret).replace(/\D/g, '').length

  if (digits === previousValue.replace(/\D/g, '')) {
    if (inputType === 'deleteContentBackward' && digitsBeforeCaret > 0) {
      digits = digits.slice(0, digitsBeforeCaret - 1) + digits.slice(digitsBeforeCaret)
      digitsBeforeCaret--
    } else if (inputType === 'deleteContentForward') {
      digits = digits.slice(0, digitsBeforeCaret) + digits.slice(digitsBeforeCaret + 1)
    }
  }

  const value = formatLeapCardNumber(digits)

  return { value, caret: positionAfterDigit(value, digitsBeforeCaret) }
}

export const leapCardNumberError = (value: string): string | null => {
  if (!value) return LEAP_CARD_REQUIRED_MESSAGE
  if (!LEAP_CARD_PATTERN.test(value)) return LEAP_CARD_INVALID_MESSAGE

  return null
}
